import React from 'react';
import FlujoFondos from './FlujoFondos';

export default function FlujoFondosHistorialPage() {
  return <FlujoFondos initialSection="historial" />;
}
